module.exports = __webpack_public_path__ + "static/media/illustration.9616698c.svg";